/* eslint-disable jsx-a11y/no-autofocus */
import React, { useState } from 'react';
import Modal from './Modal';
import StationSelector from './StationSelector';
import { usePersonChanged } from '../contexts/GlobalStateContext';

const StationUpdateForm = ({ user, onClose, initialStationName }) => {
  const [showStationSelector, setShowStationSelector] = useState(true);
  const { setPersonChanged } = usePersonChanged();

  if (!user) return null; // säkerhetskontroll

  const handleClose = () => {
    setShowStationSelector(false);
    setPersonChanged(prev => !prev); // flagga att något ändrats
    onClose?.();
  };

  return (
    <Modal labelledById="station-modal-title" onClose={handleClose} width="lg">
      <div className="tw-flex tw-flex-col tw-gap-4 tw-p-4">
        <h2 id="station-modal-title" className="tw-text-lg tw-font-semibold">
          Uppdatera stationer för {user.userName}
        </h2>

        {showStationSelector && (
          <StationSelector
            userId={user.userId}
            onClose={handleClose}
            initialStationName={initialStationName}
          />
        )}
      </div>
    </Modal>
  );
};

export default StationUpdateForm;
